const CartWidget = () => {
  return (
    <>
      <img src="/icon.png" alt="GrowshopOnline" />
    </>
  );
};

export default CartWidget;
